var angular = require('angular');
var keycode = require('keycode');
var module =  angular.module("app.directives");

module.directive('datemask', function($timeout){
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: true,
    link: function(scope, element, attrs, ngModel){
      element.attr('placeholder', 'DD/MM/YYYY');

      // element val to model.
      ngModel.$parsers.push(function toModel(value) {
        if (typeof value !== 'string') return '';
        var parts = value.split('/');
        var full = '';

        if (parts[0] && parts[0].length == 2) var day = parts[0];
        if (parts[1] && parts[1].length == 2) var month = parts[1];
        if (parts[2] && parts[2].length == 4) var year = parts[2];

        if (day && month && year) {
          full = year + '-' + month + '-' + day;
        }

        if (!full) {
          ngModel.$setValidity('full', false);
        } else {
          ngModel.$setValidity('full', true);
        }

        var dMax = 31;
        var year = year || new Date().getFullYear();

        if (month) {
          // get days in month
          dMax = new Date(year, month, 0).getDate();

          if (month > 12 || month == '00') {
            ngModel.$setValidity('month', false);
          } else {
            ngModel.$setValidity('month', true);
          }
        }

        if (day && (day > dMax || day == '00')) {
          ngModel.$setValidity('day', false);
        } else {
          ngModel.$setValidity('day', true);
        }

        return full;

      });

      // model val to input value
      ngModel.$formatters.push(function toView(value) {
        if (typeof value == 'string') {
          var d = new Date(value);
        }

        if (!d && value && value.full) {
          var d = new Date(value.full);
        }

        if (!d && value) {
          var d = value;
        }

        if (d) {
          var da = d.getDate().toString();
          var mo = (d.getMonth() + 1).toString();
          var yr = d.getFullYear().toString();
          if (da.length == 1) da = '0' + da;
          if (mo.length == 1) mo = '0' + mo;

          return da + '/' + mo + '/' + d.getFullYear();
        }

        return value;
      });

      // key prevention
      scope.keydown = function(e){
        // Allow: backspace, delete, tab, escape, enter and .
        var keyNorm = ~([46, 8, 9, 27, 13, 110]).indexOf(e.keyCode);
        // Allow: Ctrl+A, Command+A
        var keyModAll = e.keyCode == 65 && ( e.ctrlKey === true || e.metaKey === true );
        // Allow: home, end, left, right, down, up
        var keyNav = e.keyCode >= 35 && e.keyCode <= 40;
        // forward slash
        var keySlash = e.keyCode == 191 && !e.shiftKey && !e.metaKey;

        if (keyNorm || keyModAll || keyNav) return;

        if (keySlash) {
          scope.appendSlash(e);
          return;
        }

        var code = keycode(e.keyCode);
        if (code.substr(0, 7) == 'numpad ') {
          code = code = code.substr(7);
        }

        var num = parseInt(code);
        if (isNaN(num)) {
          e.preventDefault();
          return;
        }

        scope.appendNumber(e, num);
      }


      scope.appendNumber = function(e, num){
        var val = element.val();
        var len = val.length;
        var pos = element[0].selectionStart;
        var end = element[0].selectionEnd;

        var prev = val.substr(0, pos);
        var next = val.substr(pos + 1);

        // auto add slash when char 2 or char 5 entered
        if (pos == 1 || pos == 4) {
          element.val(prev + num + '/' + next);
          scope.flush();
          e.preventDefault();
          return;
        }

        // no more numbers when len is 2, 5 or 10
        if (len == 2 || len == 5 || len == 10) {
          e.preventDefault();
        }
      }

      scope.appendSlash = function(e){
        var val = element.val();
        var len = val.length;
        var pos = element[0].selectionStart;

        var prev = val.substr(0, pos);
        var next = val.substr(pos + 1);

        // prefix day/month with a leading 0
        if (pos == 1 || pos == 4) {
          var str = prev.substr(0, prev.length-1) + '0' + prev.substr(prev.length-1) + '/';
          element.val(str + next);
          scope.flush();
          e.preventDefault();
          return;
        }

        // only allow slash when 2 or 5 chars
        if (len == 2 || len == 5) {
          return;
        }

        // prevent in all casses by default.
        e.preventDefault();
      }

      // changes that are e.prevented, do not bubble values to
      // the model view value. This fn helps with that.
      scope.flush = function(){
        ngModel.$setViewValue(element.val());
      }


      element.bind('keydown', scope.keydown);

      scope.$on('$destroy', function(){
        element.unbind('keydown', scope.keydown);
      })

    }
  }
})
